module.exports = __webpack_public_path__ + "static/media/nl.367f0342.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/LanguageSwitcher/img/nl.png
 ** module id = 595
 ** module chunks = 0
 **/